// src/app/redux/sagas/formationsSaga.js
import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    FETCH_FORMATIONS_SUCCESS,
    FETCH_FORMATIONS_FAIL,
    CREATE_FORMATION_SUCCESS,
    CREATE_FORMATION_FAIL,
    UPDATE_FORMATION_SUCCESS,
    UPDATE_FORMATION_FAIL,
    DELETE_FORMATION_SUCCESS,
    DELETE_FORMATION_FAIL,
    DOWNLOAD_FORMATIONS_TEMPLATE_SUCCESS,
    DOWNLOAD_FORMATIONS_TEMPLATE_FAIL,
    IMPORT_FORMATIONS_EXCEL_SUCCESS,
    IMPORT_FORMATIONS_EXCEL_FAIL,
    EXPORT_FORMATIONS_SUCCESS,
    EXPORT_FORMATIONS_FAIL,
    FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS,
    FETCH_FORMATIONS_BY_CATALOGUE_FAIL,
    fetchFormationsRequest,
} from "../actions/formationsActions";

import {
    API_BASE_URL, 
    getRequest, 
    postRequest, 
    putRequest, 
    deleteRequest, 
    getBlobRequest,
    extractErrorMessage 
} from "../../../api";

export function* fetchFormationsByCatalogueSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid"); // si ton backend utilise header uid
    const catalogueId = action?.payload?.catalogueId;

    try {
        if (!catalogueId || String(catalogueId) === "all") {
            // soit afficher vide :
            yield put({ type: FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS, payload: [] });

            // soit appeler getAll (si tu préfères) :
            // const res = yield call(getRequest, { url: `${API_BASE_URL}/api/formations`, token, headers:{uid} });
            // yield put({ type: FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS, payload: res.data });

            return;
        }

        const res = yield call(getRequest, {
            url: `${API_BASE_URL}/api/formations/catalogues/${catalogueId}/formations`,
            token,
            headers: { uid }, // ✅ important si ton backend lit uid en header
        });

        console.log("formations by catalogue:", res.data); // ← ajoute ça

        yield put({ type: FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS, payload: res.data, catalogueId });
    } catch (e) {
        const msg = e.response?.data?.message || e.message;
        yield put({ type: FETCH_FORMATIONS_BY_CATALOGUE_FAIL, payload: msg });
    }
}

export function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

/* ======================
   FETCH LIST
====================== */
export function* fetchFormationsSaga() {
    const token = sessionStorage.getItem("token");
    try {
        console.group('🔵 FETCH_FORMATIONS_REQUEST');
        const res = yield call(getRequest, {
            url: `${API_BASE_URL}/api/formations`,
            token,
        });
        console.log('📥 Data:', res.data);
        console.groupEnd();

        yield put({ type: FETCH_FORMATIONS_SUCCESS, payload: res.data });
    } catch (e) {
        const msg = extractErrorMessage(e, "Erreur lors de la récupération des formations");
        console.error('❌ FETCH_FORMATIONS_FAIL:', msg);
        console.groupEnd();
        yield put({ type: FETCH_FORMATIONS_FAIL, error: msg });
    }
}

/* ======================
   FETCH BY CATALOGUE
====================== */


/* ======================
   CREATE (multipart)
====================== */
export function* createFormationSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const payload = action.payload;
        console.group('🔵 CREATE_FORMATION_REQUEST');
        console.log('📦 Payload:', payload);

        const cleanPayload = { ...payload };
        delete cleanPayload.imageFile;

        const fd = new FormData();
        fd.append("payload", JSON.stringify(cleanPayload));
        if (payload.imageFile) fd.append("image", payload.imageFile);

        const res = yield call(postRequest, {
            url: `${API_BASE_URL}/api/formations`,
            data: fd,
            token,
        });

        console.log('✅ CREATE_FORMATION_SUCCESS:', res.data);
        console.groupEnd();

        yield put({ type: CREATE_FORMATION_SUCCESS, payload: res.data });

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: "Formation créée avec succès",
            timer: 2000,
            showConfirmButton: false
        });
    } catch (e) {
        const msg = extractErrorMessage(e, "Erreur lors de la création de la formation");
        console.error('❌ CREATE_FORMATION_FAIL:', msg);
        console.groupEnd();

        yield put({ type: CREATE_FORMATION_FAIL, error: msg });
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

/* ======================
   UPDATE (multipart)
====================== */
export function* updateFormationSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const { id, payload } = action.payload;
        const silent = !!payload?.__silent;
        console.group('🔵 UPDATE_FORMATION_REQUEST');
        console.log('🆔 ID:', id);
        console.log('📦 Payload:', payload);

        const cleanPayload = { ...payload };
        delete cleanPayload.imageFile;
        delete cleanPayload.__silent;

        const fd = new FormData();
        fd.append("payload", JSON.stringify(cleanPayload));
        if (payload.imageFile) fd.append("image", payload.imageFile);

        const res = yield call(putRequest, {
            url: `${API_BASE_URL}/api/formations/${id}`,
            data: fd,
            token,
        });

        console.log('✅ UPDATE_FORMATION_SUCCESS:', res.data);
        console.groupEnd();

        yield put({ type: UPDATE_FORMATION_SUCCESS, payload: res.data });

        if (!silent) {
            yield call([Swal, Swal.fire], {
                icon: "success",
                title: "Succès",
                text: "Formation mise à jour avec succès",
                timer: 2000,
                showConfirmButton: false
            });
        }
    } catch (e) {
        const msg = extractErrorMessage(e, "Erreur lors de la mise à jour de la formation");
        console.error('❌ UPDATE_FORMATION_FAIL:', msg);
        console.groupEnd();

        yield put({ type: UPDATE_FORMATION_FAIL, error: msg });
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

/* ======================
   DELETE
====================== */
export function* deleteFormationSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const { id } = action.payload; // Fix: action.payload is { id }

    try {
        console.group('🔵 DELETE_FORMATION_REQUEST');
        console.log('🆔 ID:', id);

        yield call(deleteRequest, {
            url: `${API_BASE_URL}/api/formations/${id}`,
            token,
        });

        console.log('✅ DELETE_FORMATION_SUCCESS');
        console.groupEnd();

        yield put({ type: DELETE_FORMATION_SUCCESS, payload: { id } });

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Supprimé",
            text: "Formation supprimée avec succès",
            timer: 2000,
            showConfirmButton: false
        });
    } catch (e) {
        const msg = extractErrorMessage(e, "Erreur lors de la suppression de la formation");
        console.error('❌ DELETE_FORMATION_FAIL:', msg);
        console.groupEnd();

        yield put({ type: DELETE_FORMATION_FAIL, error: msg });
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur de suppression",
            text: msg
        });
    }
}

/* ======================
   TEMPLATE
====================== */
function downloadBlobAsFile(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}
export function* downloadTemplateSaga() {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const url = `${API_BASE_URL}/api/formations/template`;


        const res = yield call(getBlobRequest, {
            url,
            token,
            extraHeaders: {
                uid,
                "X-Tenant-Id": sessionStorage.getItem('selectedCompanyId'),
            },
        });

        downloadBlobAsFile(new Blob([res.data]), "template_formations.xlsx");

        yield put({ type: DOWNLOAD_FORMATIONS_TEMPLATE_SUCCESS });
    } catch (e) {
        yield put({ type: DOWNLOAD_FORMATIONS_TEMPLATE_FAIL, payload: e.response?.data || e.message });
        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template échoué" });
    }
}

/* ======================
   IMPORT EXCEL (dryRun + add/edit)
====================== */
export function* importExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const { file, dryRun, action: act } = action.payload;

    try {
        console.group('🔵 IMPORT_FORMATIONS_EXCEL_REQUEST');
        console.log('📄 File:', file.name);
        console.log('🧪 dryRun:', dryRun);
        console.log('⚡ Action:', act);

        const fd = new FormData();
        fd.append("file", file);

        const url = `${API_BASE_URL}/api/formations/import?dryRun=${dryRun ? "true" : "false"}&action=${act}`;

        const res = yield call(postRequest, {
            url,
            data: fd,
            token,
        });

        console.log('✅ IMPORT_FORMATIONS_EXCEL_SUCCESS:', res.data);
        console.groupEnd();

        yield put({ type: IMPORT_FORMATIONS_EXCEL_SUCCESS, payload: res.data });

        if (!dryRun) {
            yield call([Swal, Swal.fire], {
                icon: "success",
                title: "Import terminé",
                text: `${res.data.createdCount} lignes traitées, ${res.data.skippedCount} ignorées`,
            });
            yield put(fetchFormationsRequest());
        } else {
            yield call([Swal, Swal.fire], {
                icon: "info",
                title: "Prévisualisation",
                text: `${res.data.createdCount} lignes valides, ${res.data.skippedCount} erreurs`,
            });
        }
    } catch (e) {
        const msg = extractErrorMessage(e, "Import Excel échoué");
        console.error('❌ IMPORT_FORMATIONS_EXCEL_FAIL:', msg);
        console.groupEnd();

        yield put({ type: IMPORT_FORMATIONS_EXCEL_FAIL, error: msg });
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur import", text: msg });
    }
}

/* ======================
   EXPORT
====================== */
export function* exportExcelSaga() {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        console.group('🔵 EXPORT_FORMATIONS_REQUEST');
        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/formations/export`,
            token,
            extraHeaders: { uid }
        });

        if (res.status === 200 || res.status === 201) {
            downloadBlob(res.data, "export_formations.xlsx");
            yield put({ type: EXPORT_FORMATIONS_SUCCESS });
            console.log('✅ EXPORT_FORMATIONS_SUCCESS');
        } else {
            throw new Error("Erreur lors de l'exportation (Status " + res.status + ")");
        }
        console.groupEnd();
    } catch (e) {
        const msg = extractErrorMessage(e, "Export échoué");
        console.error('❌ EXPORT_FORMATIONS_FAIL:', msg);
        console.groupEnd();
        yield put({ type: EXPORT_FORMATIONS_FAIL, error: msg });
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}
